import { Grid } from "@mui/material"

import { Input } from "@components/Input"
import { Checkbox } from "@components/Checkbox"
import { Dropdown } from "@components/Dropdown"
import { NumberInput } from "@components/NumberInput"

import { FormComponent, FormComponentType } from "./types"
import { DatePicker } from "@components/DatePicker"
import { NameInput } from "@components/NameInput"

type FormBuilderProps = {
  field: string
  component: FormComponent
  helperText?: string
  inputWidth?: string
  dropdownWidth?: string
}

export const FormBuilder = ({
  field,
  component,
  helperText,
  inputWidth,
  dropdownWidth,
}: FormBuilderProps) => {
  const renderedComponent = () => {
    switch (component.type) {
      case FormComponentType.Input:
      case FormComponentType.Textarea:
        return (
          <Input field={field} component={component} helperText={helperText} width={inputWidth} />
        )
      case FormComponentType.Number:
        return (
          <NumberInput
            field={field}
            component={component}
            helperText={helperText}
            width={inputWidth}
          />
        )
      case FormComponentType.Checkbox:
        return <Checkbox field={field} component={component} />
      case FormComponentType.Dropdown:
        return (
          <Dropdown
            field={field}
            component={component}
            width={dropdownWidth}
            helperText={helperText}
          />
        )
      case FormComponentType.Date:
        return <DatePicker field={field} component={component} />
      case FormComponentType.NameInput:
        return (
          <NameInput
            field={field}
            component={component}
            helperText={helperText}
            width={inputWidth}
          />
        )
      default:
        return null
    }
  }

  return (
    <>
      <Grid item xs={2}>
        {component.title}
      </Grid>
      <Grid item xs={10}>
        {renderedComponent()}
      </Grid>
    </>
  )
}
